import React from 'react'
import Box from '@mui/material/Box'
import { Link } from 'react-router-dom'

interface CustomLinkProps {
    label: string;
    url: string
}

const CustomLink = (props: CustomLinkProps) => {
    const { url, label } = props;
    return <Box
        textAlign="center"
        component="h5"
        style={{ marginTop: '1vh' }}
    >
        <Link to={url}>{label}</Link>
    </Box>
}

export default CustomLink;
